import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from "@air/primitive-input";
import isNumber from "lodash/isNumber";
import { memo, useCallback, useEffect, useRef, useState } from "react";
export const PDFCurrentPageInput = /*#__PURE__*/ memo((param)=>{
    let { onGoToPage, currentPage, totalPages, onFocusChange } = param;
    const inputRef = useRef(null);
    const [value, setValue] = useState(currentPage.toString());
    useEffect(()=>{
        setValue(currentPage.toString());
    }, [
        currentPage
    ]);
    const onValueChange = useCallback((event)=>{
        setValue(event.target.value);
    }, []);
    const setNewPageFromInput = useCallback(()=>{
        if (value === currentPage.toString()) return;
        const newPage = Number(value);
        if (!isNumber(newPage)) return;
        if (newPage >= 1 && newPage <= totalPages) {
            onGoToPage(newPage);
        } else {
            setValue(currentPage.toString());
        }
    }, [
        currentPage,
        onGoToPage,
        totalPages,
        value
    ]);
    const onFocus = useCallback(()=>{
        var _inputRef_current;
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.select();
        onFocusChange(true);
    }, [
        onFocusChange
    ]);
    const onBlur = useCallback(()=>{
        setNewPageFromInput();
        onFocusChange(false);
    }, [
        onFocusChange,
        setNewPageFromInput
    ]);
    const onKeyDown = useCallback((event)=>{
        if (event.key === "Enter") {
            setNewPageFromInput();
        }
    }, [
        setNewPageFromInput
    ]);
    return /*#__PURE__*/ _jsx(Input, {
        "data-testid": "PDF_CURRENT_PAGE_INPUT",
        ref: inputRef,
        onBlur: onBlur,
        onFocus: onFocus,
        size: "small",
        type: "number",
        value: value,
        onKeyDown: onKeyDown,
        onChange: onValueChange,
        min: 1,
        max: totalPages,
        className: "w-10 text-end [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
    });
});
PDFCurrentPageInput.displayName = "PDFCurrentPageInput";
